export const environment = {
  production: false,
  apiUrl: 'https://financiadores-api-dev.kozaca.com.ar',
  auth: {
    clientId: '01a10cd3-cec0-7302-a16d-f4f975e46440',
    clientSecret: 'ZM00v6g52V1jZG7Xjg1xKgMVMDqDCyWFllSGtBSm',
  },
};
